import type { RequestParams, ScpClient } from '~shared/api/scp/client';

import type {
  CreateOrderResponse,
  FindOrdersRequestParams,
  FindOrdersResponse,
  OrdersApi,
} from './orders-api';

import type { CreateOrderRequest, OrderDetails } from '..';

interface Params {
  scpClient: ScpClient;
  host: string;
}

export class GatewayOrdersApi implements OrdersApi {
  client: ScpClient;
  host: string;

  constructor({ scpClient, host }: Params) {
    this.client = scpClient;
    this.host = host;
  }

  async createOrder(order: CreateOrderRequest) {
    return this.makeRequest<CreateOrderResponse>({
      domain: 'origination',
      service: 'web/pos-online/portal/orders',
      method: 'create',
      payload: order,
    }).then((response) => response.payload);
  }

  async getOrders(
    params: FindOrdersRequestParams
  ): Promise<FindOrdersResponse> {
    return this.makeRequest<FindOrdersResponse>({
      method: 'orders',
      payload: params,
    }).then((response) => response.payload);
  }

  async getOrder(id: string): Promise<OrderDetails> {
    return this.makeRequest<OrderDetails>({
      method: 'orders/get-by-id',
      payload: { orderId: id },
    }).then((response) => response.payload);
  }

  private makeRequest<T>(params: Partial<RequestParams> & { method: string }) {
    return this.client.call<T>({
      host: this.host,
      version: 'v1',
      domain: 'merchant-portal',
      service: 'public/dashboard',
      withCredentials: true,
      withLeadingDomain: true,
      ...params,
    });
  }
}
